export default __webpack_public_path__ + "static/media/info-i.3b444861.svg";